export enum Key {
  Enter = 'Enter',
  Space = ' ',
  Escape = 'Escape',
  Tab = 'Tab',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  Home = 'Home',
  End = 'End',
  Shift = 'Shift',
}